import { takeEvery, takeLatest, fork, call, put, all, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import FetchService from 'service/FetchService';
import {responseObject} from 'storeState/helpers';
import {authToken} from './selectors';
import {authenticatedRequest} from 'storeState/auth/saga';
import {guidGenerator} from "../../service/UtilService";
import {errorSafeSaga} from 'service/StoreService';

import * as constants from './constants';
import * as actions from './actions';

function* flashMessage(action) {
    let {message} = action.payload;
    let id = guidGenerator();
    yield put(actions.flashMessageShow({...action.payload, id}));
    yield delay(5000);
    yield put(actions.flashMessageHide({id}));
}

function* watchFlashMessage() {
    yield takeEvery(constants.FLASH_MESSAGE, errorSafeSaga(flashMessage));
}

function* saga() {
  yield all([
    fork(watchFlashMessage),
  ])
}

export default saga;



// WEBPACK FOOTER //
// ./src/storeState/ui/saga.js